import React, { useEffect } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import MakeRequest from "../Helpers/MakeRequest.js";
import { checkAuth } from "../Helpers/ProtectedRoute.js";
import { useOutletContext } from 'react-router-dom';

const loginUser = async (username, password) => {
    try {
        const response = await MakeRequest({ username, password }, "auth/login", "post");
        if(response.status < 400){
            return response.data
        };
        throw new Error("Login failed");
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

export default () => {
    const navigate = useNavigate();
    let { setIsAuthenticated } = useOutletContext();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const data = await loginUser(username, password);
            alert("Login successful")
            setIsAuthenticated(true)
            navigate('/')
        } catch (err) {
            setError(err.message || "Login failed");
        }
    };

    useEffect(() => {
        const checkLoginStatus = async () => {
            const authStatus = await checkAuth();
            if (authStatus.isAuthenticated) {
                alert("User is already logged in");
                setIsAuthenticated(true)
                navigate('/');
            };
        };
        checkLoginStatus();
    }, []);

    return (
        <Container style={{ maxWidth: 400, marginTop: 50 }}>
            <h2 className="mb-4">Admin login</h2>
            <Form onSubmit={(e)=> handleSubmit(e)}>
                <Form.Group className="mb-3" controlId="formUsername">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Form.Group>
                {error && <div style={{ color: "red" }}>{error}</div>}
                <Button variant="primary" type="submit">
                    Login
                </Button>
            </Form>
        </Container>
    );
};
